import React, { useEffect } from 'react';
import { TourCard } from '../components/TourCard';
import { internationalTours } from '../mockData';

export const InternationalTours = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="international-tours-page">
      {/* Hero Section */}
      <section className="relative h-[300px] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1528543606781-2f6e6857f318)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/80 to-emerald-900/80"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl font-bold mb-4">International Tours</h1>
          <p className="text-xl">Explore the world's most stunning destinations</p>
        </div>
      </section>

      {/* Tours Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Travel the World with Sky Trips</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              From the luxurious streets of Dubai to the romantic landscapes of Europe, from tropical beaches of 
              Southeast Asia to modern marvels – discover the world with our international tour packages.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {internationalTours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};